import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { first, switchMap, tap } from 'rxjs';
import { LotacaoAtribuicaoDto } from 'src/app/dtos/lotacoes-atribuicoes/lotacao-atribuicao-dto';
import { LotacaoAtribuicaoService } from 'src/app/servicos/lotacao-atribuicao.service';
import { PacienteService } from 'src/app/servicos/paciente.service';
import { ModalPesquisaService } from '../base-pesquisa/modal-pesquisa.service';

@Component({
  selector: 'app-lotacao-atribuicao-pesquisa',
  templateUrl: './lotacao-atribuicao-pesquisa.component.html',
  styleUrls: ['./lotacao-atribuicao-pesquisa.component.less'],
  providers: [ModalPesquisaService]
})
export class LotacaoAtribuicaoPesquisaComponent implements OnInit {

  @Output()
  registroSelecionado: EventEmitter<LotacaoAtribuicaoDto> = new EventEmitter<LotacaoAtribuicaoDto>();
  
  registros: Object | null = null;

  nomeCpf: string = '';

  constructor(private modalServico: ModalPesquisaService, 
    private pacienteService: PacienteService,
    private lotacaoService: LotacaoAtribuicaoService) { }

  ngOnInit(): void {
    this.atualizar();
  }

  selecionado(registro: LotacaoAtribuicaoDto) {
    this.registroSelecionado.next(registro);
  }

  abrirTelaCheia() {
    this.modalServico.abrirTelaCheia();
    this.atualizar();
  }

  fechar() {
    this.modalServico.fechar();
  }

  atualizar() {
    this.pacienteService.pacienteAtual$.pipe(
      first(),
      tap((paciente) => {
        if(paciente === null) {
          this.nomeCpf = '-';
          return;
        }

        this.nomeCpf = paciente.nome + ' / ' + paciente.cpf;
      }),
      switchMap((paciente) => {
        if(paciente === null)
          throw 'paciente null';

        return this.lotacaoService.listarLotacoesAtribuicoes(paciente.id);
      })
    )
    .subscribe((lotacoes) => {
      this.registros = lotacoes;
    })
  }

}
